import { useQuery } from '@tanstack/react-query';

import { fetchTaskMenu } from '@shared/api/menu';
import { useAuth } from '@features/auth/hooks/useAuth';

const taskMenuKey = (cacheUserID: number) => ['menu', cacheUserID, 'tasks'] as const;

export function useTaskMenu() {
  const { user } = useAuth();
  // Client cache partition only; it is never sent as menu authorization.
  const cacheUserID = user?.id ?? 0;
  return useQuery<Awaited<ReturnType<typeof fetchTaskMenu>>, Error>({
    queryKey: taskMenuKey(cacheUserID),
    queryFn: fetchTaskMenu,
    enabled: cacheUserID > 0,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

export { taskMenuKey };
